module.exports = __webpack_public_path__ + "assets/certificate_pdf/p20.b0b67b37.pdf";